import { call, put } from "redux-saga/effects";

export default function* processAction(action) {
  const { params, service, success, failed } = action;
  const parameters = Object.values(params).map(item => item)
  try {
    const payload = Array.isArray(parameters)
      ? yield call(service, ...parameters)
      : yield call(service, parameters);
    yield put({ type: !payload.error ? success : failed, payload });
  } catch (error) {
    yield put({ type: failed, error });
  }
}



// WEBPACK FOOTER //
// ./src/utils/processAction.js